import React from "react";
import { observer } from "mobx-react";
import { Button, Checkbox, TextField } from "@material-ui/core";
import { get, jsonParser, multipartForm, post, put } from "../../utils/Client";
import CheckBox from "../../components/CheckBox";
import ImageUpload from "../../components/ImageUpload";


class PurchaseCertificates extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      config: {
        title: "",
        subtitle: "",
        warrantyTitle: "",
        warranty: "",
        warrantyUrl: "",
        usageTitle: "",
        usage: "",
        usageUrl: "",
        footer: "",
        showTicket: true,
        showSkus: true,
        showQuantity: true,
        showCustomerName: true,
        showName: true,
      },
      loading: false,
      submitting: false,
      error: "",
      pdfData: null,
    }
  }

  componentDidMount() {
    this.setState({ loading: true }, this.getConfig);
  }

  getConfig = async () => {
    try{
      const res = await get(`/purchase-certificates/current`).then(jsonParser);
      this.setState({ error: "", loading: false, config: res });
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao carregar dados do servidor. Tente novamente mais tarde", loading: false });
    }
  }

  getPdf = async () => {
    try{
      const res = await post(`/purchase-certificates/test`, { body: this.state.config });
      if(res.status !== 200){
        const message = await res.text();
        throw new Error(message);
      }
      const pdfBytes = await res.arrayBuffer();
      const base64 = btoa(new Uint8Array(pdfBytes).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      this.setState({ error: "", submitting: false, pdfData: base64 });
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao carregar dados do servidor. Tente novamente mais tarde", submitting: false });
    }
  }

  submit = async () => {
    try{
      const { config } = this.state;
      await put(`/purchase-certificates/${config.id}`, { body: config }).then(jsonParser);
      this.setState({ submitting: false, error: "", loading: true }, this.getConfig);
    } catch(e){
      console.log(e.message ?? e);
      this.setState({ error: e.message ?? "Erro ao salvar configuração", submitting: false });
    }
  }

  handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    const name = file?.name;

    // limpa o input pra permitir reenvio do mesmo arquivo
    e.target.value = "";

    if (!file) return;

    if (file.size > 20000000) {
      this.setState({ error: "O arquivo não pode ser maior que 20MB" });
      return;
    }

    this.setState({ submitting: true, error: "" });

    try {
      const { config } = this.state;
      const formData = new FormData();
      formData.append("file", file, name);

      await multipartForm(`/purchase-certificates/upload-html/${config.id}`, { body: formData })
        .then(jsonParser);

      this.setState({ submitting: false, error: "", loading: true }, this.getConfig);
    } catch (err) {
      console.log(err.message ?? err);
      this.setState({ submitting: false, error: err.message ?? "Erro ao salvar o arquivo" });
    }
  };

  render() {
    const { submitting, loading, error, config, pdfData } = this.state;

    return (
      <div className="holder" style={styles.container}>
        <h4>
          Envie uma notificação para as vendedoras
        </h4>

        <div style={styles.body}>
          <div style={styles.form}>
            <TextField
              value={config.title}
              label="Digite o título {{TITLE}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, title: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.title?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <TextField
              value={config.subtitle}
              label="Digite o subtítulo {{SUBTITLE}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, subtitle: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.subtitle?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <TextField
              value={config.warrantyTitle}
              label="Digite o título do card de garantia {{WARRANTY_TITLE}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, warrantyTitle: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.warrantyTitle?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <TextField
              value={config.warranty}
              label="Digite o texto do card de garantia {{WARRANTY}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, warranty: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.warranty?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <TextField
              value={config.warrantyUrl}
              label="Digite a url do card de garantia {{WARRANTY_URL}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, warrantyUrl: e.target.value }})}
              fullWidth
              disabled={loading || submitting}
            />
            <TextField
              value={config.usageTitle}
              label="Digite o título do card de cuidados {{USAGE_TITLE}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, usageTitle: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.usageTitle?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <TextField
              value={config.usage}
              label="Digite o texto do card de cuidados {{USAGE}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, usage: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.usage?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <TextField
              value={config.usageUrl}
              label="Digite a url do card de cuidados {{USAGE_URL}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, usageUrl: e.target.value }})}
              fullWidth
              disabled={loading || submitting}
            />
            <TextField
              value={config.footer}
              label="Digite o texto do rodapé {{FOOTER}}"
              variant="outlined"
              multiline={true}
              onChange={(e) => this.setState({ config: { ...config, footer: e.target.value.substring(0, 100) }})}
              fullWidth
              helperText={`${config.footer?.length ?? "0"}/100`}
              disabled={loading || submitting}
            />
            <div style={{ color: "#000", fontSize: 14, textAlign: "start" }}>
              <div>{"{{TICKET_ID}} -> substitui pelo número do ticket"}</div>
              <div>{"{{SKUS}} -> substitui por lista dos SKUs comprados"}</div>
              <div>{"{{QUANTITY}} -> substitui pela quantidade de SKUs comprados"}</div>
              <div>{"{{CUSTOMER_NAME}} -> substitui pelo nome do(a) cliente"}</div>
              <div>{"{{VENDOR_NAME}} -> substitui pelo nome do(a) vendedor(a)"}</div>
              <div style={{ marginTop: 10 }}>{"Chaves que não estiverem presentes no html serão ignoradas"}</div>
            </div>
            <Button variant="outlined" component="label" disabled={loading || submitting}>
              Enviar template HTML
              <input 
                type="file"
                hidden
                accept=".html"
                onChange={this.handleFileChange}
              />
            </Button>
          </div>


          { (!!error) &&
            <div style={{ color: "#FF0000", fontSize: 12, width: "100%", textAlign: "left", marginBottom: 20 }}>
              {error}
            </div>
          }
          <div style={{ display: "flex", flexDirection: "row", gap: 20, width: "100%", justifyContent: "center" }}>
            <Button 
              onClick={() => this.setState({ submitting: true, pdfData: null }, this.getPdf)}
              disabled={submitting || loading}
              size="medium"
              variant="outlined"
              color="default"
            >
              Testar
            </Button>
            <Button 
              onClick={() => this.setState({ submitting: true }, this.submit)}
              disabled={submitting || loading}
              size="medium"
              variant="outlined"
              color="default"
            >
              Salvar
            </Button>
          </div>

        </div>
        { !!pdfData &&
          <div style={{ marginTop: 20, width: "100%" }}>
            <iframe
              src={`data:application/pdf;base64,${pdfData}#toolbar=0&view=fitH`}
              style={{ width: "210mm", height: "297mm", border: 0 }}
            />
          </div>
        }
      </div>
    );
  }
}

export default observer(PurchaseCertificates);

const styles = {
  container               : {
    paddingLeft               : 10,
    paddingTop                : 10,
    width                     : "80%",
  },
  subHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
  panelsStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  checkBox: {
    marginRight: 5,
    padding: 3,
    alignSelf: "flex-start",
  },
  body: { 
    paddingLeft: 20, 
    paddingRight: 30, 
  },
  form: {
    display: "grid",
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: 20,
    marginBottom: 20,
  },
};